<template>
  <v-container class="ma-0 pa-0 mb-5" fluid v-if="! $auth.loading">
    <!-- Small screen -->
    <v-row class="hidden-sm-and-up ma-5">
      <v-img
          src="/images/pp-logo.png"
          height="25"
          contain
      />

      <div v-if="!$auth.loading">
        <v-btn
            class="rounded-xl"
            color="primary"
            dark
            v-if="$auth.isAuthenticated"
            @click="logout">
          Logout
        </v-btn>
      </div>
    </v-row>

    <!-- Medium and above screen -->
    <v-container fluid class="cms-header hidden-sm-and-down">
      <v-row>
        <v-col cols="2">
          <v-img
              src="/images/pp-logo.png"
              height="25"
              contain
              />
        </v-col>

        <v-col cols="6" class="font-weight-bold grey--text pp-center">
          <span class="white--text font-weight-black">
           VLE:
          </span>
          Virtual Learning Environment: Content Management System <small>{{ appVersion }}</small>
        </v-col>


        <v-col class="d-flex mr-3">
          <v-row class="my-auto align-right">
            <div class="mr-3">
              Hi, {{ auth0AccessToken.name }}
            </div>

            <div>
              <v-img
                  :src=auth0AccessToken.picture
                  width="25"
                  height="25"
                  class="rounded-xl"/>
            </div>
          </v-row>
        </v-col>

        <v-col cols="1" class="d-flex justify-end">
          <v-btn
              height="25"
              text
              @click="logout"
              class="grey--text"
          >
            Log Out
            <v-icon
                class="ml-2"
                v-if="$auth.isAuthenticated"
            >
              mdi-logout
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    </v-container>
</template>

<script>

import { mapGetters, mapState } from "vuex";

export default {
  name: "Header",
  components: {},
  computed: {
    ...mapState(['auth0AccessToken']),
    ...mapGetters(['auth0AccessToken', 'appVersion']),
  },
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};

</script>

<style scoped>
.cms-header {
  font-weight: bold;
  background-color: var(--darkblue);
  color: lightgray;
  border-bottom: var(--primary) 5px solid;
}

.align-right {
  justify-content: right;
  position: relative;
  text-align: right;
}
</style>
